<template>
  <div class="container">
    <div class="filter-content">
      <div class="filter-list">
        <div class="filter-item flex">
          <span class="filter-label">项目类型:</span>
          <ul class="flex filter-option-list">
            <li
              v-for="(item, index) in projectTypeList"
              :key="index"
              class="filter-option"
              :class="{ active: item.code === searchForm.projectType }"
              @click="selectFilter('projectType', item.code)"
            >
              {{ item.label }}
            </li>
          </ul>
        </div>
        <div class="filter-item flex">
          <span class="filter-label">公告类型:</span>
          <ul class="flex filter-option-list">
            <li
              v-for="(item, index) in noticeTypeList"
              :key="index"
              class="filter-option"
              :class="{ active: item.code === searchForm.noticeType }"
              @click="selectFilter('noticeType', item.code)"
            >
              {{ item.label }}
            </li>
          </ul>
        </div>
        <div class="filter-item flex">
          <span class="filter-label">项目状态:</span>
          <ul class="flex filter-option-list">
            <li
              v-for="(item, index) in statusList"
              :key="index"
              class="filter-option"
              :class="{ active: item.code === searchForm.status }"
              @click="selectFilter('status', item.code)"
            >
              {{ item.label }}
            </li>
          </ul>
        </div>
      </div>
      <div class="filter-total flex align-center">
        <span class="color-666">当前记录 <em class="color-theme-red">{{ total }}</em> 条</span>
      </div>
    </div>
    <div class="list-content">
      <el-table
        v-if="list.length || loading"
        ref="projectTableRef"
        v-loading="loading"
        class="project-table"
        :data="list"
        fit
        :default-sort="{prop: 'endTime', order: null}"
        :header-cell-style="headerCellStyle"
        :cell-style="cellStyle"
        @sort-change="handleSortChange"
        @row-click="rowClick"
      >
        <el-table-column label="项目名称" min-width="180">
          <template slot-scope="scope">
            <span class="text-cut" :title="scope.row.gonggaoTitle">{{ scope.row.gonggaoTitle }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="purchaseWayName" label="采购方式" width="180" />
        <el-table-column prop="endTime" label="截止时间" width="160" sortable="custom" />
        <el-table-column label="状态" width="120">
          <template slot-scope="scope">
            <div class="table-btn" :style="{backgroundColor: ['1', '3'].includes(scope.row.status) ? '#DC4B19' : '#999'}">{{ scope.row.status_name }}</div>
          </template>
        </el-table-column>
      </el-table>
      <div v-else style="height: 450px">
        <no-data />
      </div>

      <el-pagination
        class="table-pagination flex-center"
        hide-on-single-page
        background
        :current-page="curPage"
        :page-size="pageSize"
        :pager-count="5"
        prev-text="上一页"
        next-text="下一页"
        layout=" prev, pager, next, slot"
        :total="total"
        @current-change="handleCurrentChange"
      >
        <div class="flex align-center color-666">
          <div>共{{ curPage }}页/共{{ total }}条数据</div>
          <div class="flex-center ml-20">
            <p>转到</p>
            <el-input-number v-model="curSdPage" class="page-input" :controls="false" :min="1" :max="maxPage" :step="1" step-strictly />
            <p class="ml-5">页</p>
            <el-button class="jump-btn" @click="handleCurrentChange(curSdPage)">确定</el-button>
          </div>
        </div>
      </el-pagination>
    </div>
  </div>
</template>

<script>
import purchaseApi from "@/api/purchase";
import {
  PROJECT_TYPE_OPTIONS,
  INFO_TYPE_OPTIONS,
  PROJECT_STATUS_OPTIONS,
  ORGANIZATION_OPTIONS, getConstantDic
} from "@/utils/constant";
import NoData from "@/components/NoData.vue";
import { mapActions } from "vuex";

export default {
  name: "ProjectList",
  components: {
    NoData
  },
  props: {},
  data() {
    return {
      // 项目类型  工程：GC 货物：HW 服务：FW 其他：QT）
      projectTypeList: getConstantDic(PROJECT_TYPE_OPTIONS),
      // 公告类型
      noticeTypeList: getConstantDic(INFO_TYPE_OPTIONS),
      // 项目状态  未开始：0 报名中：1 报名截止：2 公示中：3 公示结束 ：4 已中标：5 已废标：6）
      statusList: getConstantDic(PROJECT_STATUS_OPTIONS),
      // 组织单位
      fbDwGuidList: getConstantDic(ORGANIZATION_OPTIONS),
      searchForm: {
        title: "",
        projectType: "",
        noticeType: "",
        status: "",
        fbDwGuid: "",
        orderType: "default" // (默认：default  报名截止时间升序：baoMingEndDate_up 报名截止时间降序：baoMingEndDate_down)
      },
      list: [],
      curPage: 1,
      curSdPage: 1,
      pageSize: 18,
      total: 0,
      loading: false
    };
  },
  // 监听属性 类似于data概念
  computed: {
    maxPage() {
      return Math.ceil(this.total / this.pageSize)
    }
  },
  watch: {
    curPage(val) {
      this.curSdPage = val
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    const params = this.$route.query
    Object.assign(this.searchForm, params)
    this.getList()
    this.changeActiveMenu()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  // 方法集合
  methods: {
    ...mapActions("permission", ["getActiveMenu"]),
    updateUrlWithoutReload(newPath, newQuery) {
      const url = new URL(window.location.href);

      if (newPath) {
        url.pathname = newPath;
      }

      if (newQuery) {
        Object.keys(newQuery).forEach(key => {
          url.searchParams.set(key, newQuery[key]);
        });
      }
      // 使用 replaceState 更新 URL 而不触发页面刷新
      window.history.replaceState({}, "", url.href);
      this.changeActiveMenu()
    },
    changeActiveMenu() {
      const code = this.searchForm.projectType.toLowerCase() || this.$route.params.code
      this.getActiveMenu({ params: { ...this.$route.params, code }})
    },
    // 选择筛选条件
    selectFilter(type, value) {
      // console.log(type, value)
      this.searchForm[type] = value
      switch (type) {
        case "projectType":
          this.updateUrlWithoutReload(this.$route.path, { ...this.$route.query, projectType: value })
          break
        case "noticeType":
          this.updateUrlWithoutReload(this.$route.path, { ...this.$route.query, noticeType: value })
          break
        case "status":
          this.updateUrlWithoutReload(this.$route.path, { ...this.$route.query, status: value })
          break
      }
      this.getList("0")
    },
    // 获取列表
    getList(type) {
      this.loading = true

      if (type === "0") {
        this.curPage = 1
      }
      const params = {
        pageNo: this.curPage,
        pageSize: this.pageSize,
        ...this.searchForm
      }
      purchaseApi.page(params).then(res => {
        if (res.code === 0) {
          const data = res.data || {}
          const list = data.list || []
          this.total = data.total || 0
          const statusList = Object.values(PROJECT_STATUS_OPTIONS)
          list.forEach(e => {
            e.status_name = statusList.find(f => f.code === e.status).label
          })
          this.list = data.list || []
        }
      }).finally(() => {
        this.loading = false
      })
    },
    headerCellStyle({ columnIndex }) {
      let str = "background-color: #f9f9f9;padding: 8px 0;"
      if (columnIndex === 0 || columnIndex === 3) {
        str += "text-align: center;"
      }
      return str
    },
    cellStyle({ columnIndex }) {
      let str = "border: none;padding: 10px 0;cursor:pointer;"
      if (columnIndex === 3) {
        str += "display: flex;justify-content: center;"
      }
      return str
    },
    // 翻页
    handleCurrentChange(val) {
      this.curPage = Number(val)
      this.getList()
    },
    // 行点击
    rowClick(row) {
      this.$router.push({
        name: "projectDetail",
        query: {
          id: row.id,
          infoid: row.infoid,
          noticeType: this.searchForm.noticeType
        }
      })
    },
    // 排序
    handleSortChange({ order }) {
      this.searchForm.orderType = order === "descending" ? "baoMingEndDate_down" : order === "ascending" ? "baoMingEndDate_up" : "default"
      this.getList("0")
    }
  }
}
</script>

<style scoped lang="scss">
  .container{
    padding-bottom: 30px;
  }
  .filter-content {
    padding: 0 10px;
    background-color: #fff;
    border: 1px solid #ddd;
    .filter-list {
      padding: 20px 10px;
      .filter-item {
        .filter-label {
          width: 90px;
          min-width: 90px;
          text-align: right;
          color: #666;
          font-size: 14px;
        }
        .filter-option-list {
          margin-left: 20px;
          flex-wrap: wrap;
          .filter-option {
            height: 24px;
            line-height: 22px;
            padding: 0 10px;
            border: 1px solid #fff;
            border-radius: 24px;
            margin: 0 10px 10px 0;
            cursor: pointer;
            &:hover {
              color: $--color-primary;
              border-color: $--color-primary;
            }
          }
          .active {
            color: $--color-primary;
            border-color: $--color-primary;
          }
        }
      }
      .filter-item + .filter-item {
        margin-top: 10px;
      }
    }
    .filter-total {
      border-top: 1px dashed #ddd;
      height: 50px;
    }
  }
  .list-content{
    margin-top: 20px;
    border: 1px solid #ddd;
    padding-bottom: 30px;
  }
  .project-table {
    &::before{
      height: 0;
    }
    .table-btn {
      width: 70px;
      height: 24px;
      color: #fff;
      text-align: center;
    }
  }
  .table-pagination {
    margin-top: 35px;
    ::v-deep {
      .el-pager li{
        width: 34px;
        height: 34px;
        line-height: 34px;
        background-color: #fff;
        color: #666;
        border: 1px solid #ddd;
      }
      .btn-prev,
      .btn-next {
        width: 70px;
        height: 34px;
        background-color: #fff;
        color: #666;
        border: 1px solid #ddd;
      }
      .btn-next {
        margin-right: 10px;
      }
    }
    .page-input{
      width: 60px;
      margin-left: 5px;
      ::v-deep .el-input__inner{
        height: 33px;
        padding: 0 5px;
      }
    }
    .jump-btn{
      width: 50px;
      height: 33px;
      background: #BBBBBB;
      border-radius: 0;
      margin-left: 10px;
      color: #fff;
    }
  }
</style>
